import axios from 'axios';
import store from '../store/store';
import { logout } from '../store/userSlice';
import { API_BASE_URL } from '../config';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // If we receive a token in the response, set it in axios headers for subsequent requests
    if (response.data && response.data.token) {
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
    }
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle 401 Unauthorized error (expired token) but don't redirect for auth endpoints
      if (error.response.status === 401 && 
          !error.config.url.includes('/auth/login') && 
          !error.config.url.includes('/auth/signup')) {
        // Clear user data and token
        store.dispatch(logout());
        
        // Redirect to login page for expired tokens (but not login/register failures)
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 